import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { browserHistory } from 'react-router';
import Button from 'react-bootstrap/lib/Button';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Alert from 'react-bootstrap/lib/Alert';
import DraftList from 'components/drafts/DraftList';
import DraftSearchForm from 'components/drafts/DraftSearchForm';
import DownloadDraftsDialog from 'components/drafts/DownloadDraftsDialog';
import {
  fetchDrafts, deleteDraft,
  sendDraft, deliverDraft, convertDraft, completeDraft, duplicateDraft,
  selectDraft, importShopifyDrafts, issueManualInvoice,
  initDraftsSocket, exportDraftsBulk, validateCustomerForConvert
} from 'modules/drafts';
import { fetchAccount } from 'modules/account';

class Drafts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 20,
      selected: {}
    };
  }

  componentDidMount() {
    let filter = { page: 1, limit: this.state.sizePerPage };
    this.props.dispatch(fetchAccount());
    this.props.dispatch(fetchDrafts(filter));
    this.props.dispatch(importShopifyDrafts());
    this.props.dispatch(initDraftsSocket());
  }

  searchDrafts(filter) {
    filter.page = 1;
    filter.limit = this.state.sizePerPage;
    this.setState({ page: 1 });
    this.props.dispatch(fetchDrafts(filter));
  }

  createNewDraft() {
    browserHistory.push('/drafts/edit/new');
  }

  editDraft(draft) {
    browserHistory.push('/drafts/edit/' + (draft.id || draft._id));
  }

  onDeleteDraft(id) {
    const t = (msgId, values) => this.props.intl.formatMessage({ id: msgId }, values);
    if (confirm(t('drafts.confirmDelete'))) {
      this.props.dispatch(deleteDraft(id));
    }
  }

  onSendDraft(id) {
    this.props.dispatch(sendDraft(id));
  }

  onDeliverDraft(id) {
    this.props.dispatch(deliverDraft(id));
  }

  onConvertDraft(id) {
    const t = (msgId, values) => this.props.intl.formatMessage({ id: msgId }, values);
    this.props.dispatch(validateCustomerForConvert(id)).then((validation) => {
      if (!validation) {
        this.props.dispatch(convertDraft(id));
        return;
      }

      let { customerExists, warnings, canCreateCustomer } = validation;

      if (customerExists) {
        this.props.dispatch(convertDraft(id));
        return;
      }

      if (warnings.length > 0 && !canCreateCustomer) {
        let msg = t('drafts.incompleteCustomer') + '\n- ' + warnings.join('\n- ') +
          '\n\n' + t('drafts.pushWithoutCustomer');
        if (confirm(msg)) {
          this.props.dispatch(convertDraft(id, true));
        }
        return;
      }

      let msg = t('drafts.customerNotInShopify') + '\n';
      if (warnings.length > 0) {
        msg += t('drafts.warnings') + '\n- ' + warnings.join('\n- ') + '\n\n';
      }
      msg += t('drafts.createCustomerAndPush');
      if (confirm(msg)) {
        this.props.dispatch(convertDraft(id, false));
      }
    }).catch(() => {
      this.props.dispatch(convertDraft(id));
    });
  }

  onCompleteDraft(id) {
    this.props.dispatch(completeDraft(id));
  }

  onDuplicateDraft(id) {
    this.props.dispatch(duplicateDraft(id));
  }

  onIssueDraft(id) {
    this.props.dispatch(issueManualInvoice(id));
  }

  onRowSelect(row, isSelected) {
    let selected = { ...this.state.selected };
    if (isSelected) {
      selected[row.id] = true;
    } else {
      delete selected[row.id];
    }
    this.setState({ selected });
  }

  onSelectAll(isSelected, rows) {
    let selected = { ...this.state.selected };
    rows.forEach(row => {
      if (isSelected) {
        selected[row.id] = true;
      } else {
        delete selected[row.id];
      }
    });
    this.setState({ selected });
  }

  showDownloadDialog() {
    this._downloadDialog.getWrappedInstance().wrappedInstance.show();
  }

  downloadDrafts(settings) {
    this.props.dispatch(exportDraftsBulk(this.state.selected, settings));
    this._downloadDialog.getWrappedInstance().wrappedInstance.hide();
  }

  onPageChange(page, sizePerPage) {
    this.setState({ page, sizePerPage });
    let filter = { ...this.props.drafts.filter, page, limit: sizePerPage };
    this.props.dispatch(fetchDrafts(filter));
  }

  render() {
    const t = (id, values) => this.props.intl.formatMessage({ id }, values);
    let { drafts, user } = this.props;
    let selectedCount = Object.keys(this.state.selected).length;
    let now = new Date();
    let thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

    return (
      <div>
        <Grid fluid>
          <div className="sidebar">
            <Col md={6}>
              <span>{t('drafts.title')}</span>
            </Col>
            <Col md={6}>
              <div className="btn-group pull-right">
                <Button
                  bsStyle="default"
                  disabled={drafts.exporting}
                  onClick={() => this.showDownloadDialog()}
                >
                  <i className="fa fa-download"></i>{' '}
                  {drafts.exporting ? t('drafts.exporting', { status: drafts.exportStatus }) : t('drafts.download')}
                  {selectedCount > 0 && !drafts.exporting && ` (${selectedCount})`}
                </Button>{' '}
                <Button bsStyle="success" onClick={() => this.createNewDraft()}>
                  <i className="fa fa-plus"></i> {t('drafts.newDraft')}
                </Button>
              </div>
            </Col>
          </div>
        </Grid>

        <div className="container-fluid drafts-container">
          {drafts.needsReauth && (
            <Alert bsStyle="warning">
              <i className="fa fa-exclamation-triangle"></i>&nbsp;
              {t('drafts.accessNotGranted')} <a href={'/auth/sp?shop=' + (this.props.user && this.props.user.shopify ? this.props.user.shopify.shopName : '')}>{t('drafts.reLogin')}</a> {t('drafts.toGrantPermissions')}
            </Alert>
          )}

          {drafts.convertError && (
            <Alert bsStyle="danger">
              <i className="fa fa-exclamation-circle"></i>&nbsp;{t('drafts.pushFailed')} {drafts.convertError}
            </Alert>
          )}

          {drafts.saveError && (
            <Alert bsStyle="danger">
              <i className="fa fa-exclamation-circle"></i>&nbsp;{drafts.saveError}
            </Alert>
          )}

          {drafts.exportError && (
            <Alert bsStyle="danger" onDismiss={() => {}}>
              <i className="fa fa-exclamation-circle"></i>&nbsp;{t('drafts.exportError')} {drafts.exportError}
            </Alert>
          )}

          <Row>
            <Col md={12} className="collapsable open">
              <DraftSearchForm onSearch={(filter) => this.searchDrafts(filter)} />
            </Col>
          </Row>

          <DraftList
            list={drafts.list}
            totalCount={drafts.totalCount}
            fetching={drafts.fetching}
            user={user}
            page={this.state.page}
            sizePerPage={this.state.sizePerPage}
            onEdit={(draft) => this.editDraft(draft)}
            onDelete={(id) => this.onDeleteDraft(id)}
            onSend={(id) => this.onSendDraft(id)}
            onDeliver={(id) => this.onDeliverDraft(id)}
            onConvert={(id) => this.onConvertDraft(id)}
            onComplete={(id) => this.onCompleteDraft(id)}
            onDuplicate={(id) => this.onDuplicateDraft(id)}
            onIssue={(id) => this.onIssueDraft(id)}
            onRowSelect={(row, isSelected) => this.onRowSelect(row, isSelected)}
            onSelectAll={(isSelected, rows) => this.onSelectAll(isSelected, rows)}
            onPageChange={(page, sizePerPage) => this.onPageChange(page, sizePerPage)}
          />
        </div>

        <DownloadDraftsDialog
          ref={(i) => { this._downloadDialog = i; }}
          user={user}
          intl={this.props.intl}
          dispatch={this.props.dispatch}
          onOk={(settings) => this.downloadDrafts(settings)}
          initialValues={{
            what: 'selected',
            format: 'pdf',
            status: 'any',
            document_type: 'any',
            created_at_min: thirtyDaysAgo.toISOString(),
            created_at_max: now.toISOString()
          }}
          dialogTitle={t('drafts.downloadTitle')}
          closeButtonLabel={t('drafts.cancel')}
        />
      </div>
    );
  }
}

Drafts.propTypes = {
  drafts: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    drafts: state.drafts,
    user: state.account
  };
}

export default injectIntl(connect(mapStateToProps)(Drafts));



// WEBPACK FOOTER //
// app/containers/Drafts.jsx